import type { IAuthRepository } from '../../domain/ports';
import { authApi } from '../api';
import type {
  LoginCredentials,
  LoginResult,
  TwoFactorVerification,
  TwoFactorResult,
  TokenRefreshResult,
  UserProfile,
  UpdateProfileData,
  ChangePasswordData,
  ChangeEmailData,
  VerifyEmailChangeData,
  DeleteAccountData,
  DeleteAccountResult,
  ApiResponse,
} from '../../application/dto/dtos';

/**
 * Adapte authApi vers le port IAuthRepository.
 */
export class AuthRepository implements IAuthRepository {
  login(credentials: LoginCredentials): Promise<ApiResponse<LoginResult>> {
    return authApi.login(credentials);
  }

  verify2FA(data: TwoFactorVerification): Promise<ApiResponse<TwoFactorResult>> {
    return authApi.verify2FA(data);
  }

  logout(): Promise<ApiResponse<void>> {
    return authApi.logout();
  }

  refreshToken(): Promise<ApiResponse<TokenRefreshResult>> {
    return authApi.refreshToken();
  }

  getProfile(): Promise<ApiResponse<UserProfile>> {
    return authApi.getProfile();
  }

  updateProfile(data: UpdateProfileData): Promise<ApiResponse<UserProfile>> {
    return authApi.updateProfile(data);
  }

  changePassword(data: ChangePasswordData): Promise<ApiResponse<void>> {
    return authApi.changePassword(data);
  }

  changeEmail(data: ChangeEmailData): Promise<ApiResponse<void>> {
    return authApi.changeEmail(data);
  }

  verifyEmailChange(data: VerifyEmailChangeData): Promise<ApiResponse<void>> {
    return authApi.verifyEmailChange(data);
  }

  deleteAccount(data: DeleteAccountData): Promise<ApiResponse<DeleteAccountResult>> {
    return authApi.deleteAccount(data);
  }
}
